import { render, staticRenderFns } from "./Advantage.vue?vue&type=template&id=48114701&scoped=true"
import script from "./Advantage.vue?vue&type=script&lang=js"
export * from "./Advantage.vue?vue&type=script&lang=js"
import style0 from "./Advantage.vue?vue&type=style&index=0&id=48114701&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48114701",
  null
  
)

export default component.exports